export const spriteKey = (sprite) => `${sprite.action_id}`;

export const getSpriteSmallImagePath = (sprite) => (
  `/s/small/${sprite.char_id}_${sprite.outfit_id}_${sprite.action_id}.webp`
);

export const formatSpriteNameForDisplay = (name) => {
  const resolvedName = typeof name === 'string' ? name.trim() : '';
  if (!resolvedName) return '';
  return resolvedName.replace(/_/g, ' ');
};

export const formatSpriteNameForPublish = (name) => {
  const displayName = formatSpriteNameForDisplay(name);
  if (!displayName) return '';
  return displayName.replace(/\s+/g, '_');
};
